module.exports = __webpack_public_path__ + "static/media/melo4.d6f80b05.ogg";